// extracted by mini-css-extract-plugin
export default {"dailyScoopContent":"dailyScoop_dailyScoopContent__ZdFt+","titleWrapper":"dailyScoop_titleWrapper__5lNFr","title":"dailyScoop_title__KiCgO","divider":"dailyScoop_divider__YT964"};